/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecoveryCashOnDeliveryResponse } from '../../models/recovery-cash-on-delivery-response';
import { RecoveryCashOnDeliveryUpdateRequest } from '../../models/recovery-cash-on-delivery-update-request';

export interface PutFeV1RecoveryCodsId$Json$Params {

/**
 * The hashed recovery COD ID.
 */
  id: string;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;

/**
 * Unique identifier for tracing the request across services
 */
  'X-Correlation-Id'?: string;
  
    /**
     * Recovery COD update data.
     */
    body?: RecoveryCashOnDeliveryUpdateRequest
}

export function putFeV1RecoveryCodsId$Json(http: HttpClient, rootUrl: string, params: PutFeV1RecoveryCodsId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveryCashOnDeliveryResponse>> {
  const rb = new RequestBuilder(rootUrl, putFeV1RecoveryCodsId$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.header('X-Correlation-Id', params['X-Correlation-Id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecoveryCashOnDeliveryResponse>;
    })
  );
}

putFeV1RecoveryCodsId$Json.PATH = '/v1/recovery-cods/{id}';
